import { render, staticRenderFns } from "./Exchanges.vue?vue&type=template&id=3cf54f6f&lang=pug"
import script from "./Exchanges.vue?vue&type=script&lang=js"
export * from "./Exchanges.vue?vue&type=script&lang=js"
import style0 from "./Exchanges.vue?vue&type=style&index=0&id=3cf54f6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports